/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AzureTenantDiscoveryRequest,
  AzureTenantDiscoveryResponse,
  CsrfTokenResponse,
  DomainLookupResult,
  LogoutRequest,
  LogoutResponse,
  UserInfoResponse,
} from '../models/index';
import {
    AzureTenantDiscoveryRequestFromJSON,
    AzureTenantDiscoveryRequestToJSON,
    AzureTenantDiscoveryResponseFromJSON,
    AzureTenantDiscoveryResponseToJSON,
    CsrfTokenResponseFromJSON,
    CsrfTokenResponseToJSON,
    DomainLookupResultFromJSON,
    DomainLookupResultToJSON,
    LogoutRequestFromJSON,
    LogoutRequestToJSON,
    LogoutResponseFromJSON,
    LogoutResponseToJSON,
    UserInfoResponseFromJSON,
    UserInfoResponseToJSON,
} from '../models/index';

export interface DiscoverAzureTenantGetRequest {
    domain: string;
}

export interface DiscoverAzureTenantPostRequest {
    azureTenantDiscoveryRequest: AzureTenantDiscoveryRequest;
}

export interface DiscoverByEmailRequest {
    email: string;
}

export interface DiscoverDomainRequest {
    domain: string;
}

export interface GetUserInfoRequest {
    authorization: string;
}

export interface LogoutOperationRequest {
    logoutRequest: LogoutRequest;
}

/**
 * AuthenticationApi - interface
 * 
 * @export
 * @interface AuthenticationApiInterface
 */
export interface AuthenticationApiInterface {
    /**
     * Discover Azure AD tenant ID from a domain name. Same as POST /discover/azure-tenant but uses path parameter.
     * @summary Discover Azure AD tenant from domain (GET)
     * @param {string} domain Domain name to discover
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverAzureTenantGetRaw(requestParameters: DiscoverAzureTenantGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AzureTenantDiscoveryResponse>>;

    /**
     * Discover Azure AD tenant ID from a domain name. Same as POST /discover/azure-tenant but uses path parameter.
     * Discover Azure AD tenant from domain (GET)
     */
    discoverAzureTenantGet(requestParameters: DiscoverAzureTenantGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AzureTenantDiscoveryResponse>;

    /**
     * Discover Azure AD tenant ID from a domain name by checking all Azure cloud environments.  **Clouds Checked:** - Public Azure (login.microsoftonline.com) - US Government (login.microsoftonline.us) - China (login.chinacloudapi.cn) - Germany (login.microsoftonline.de)  **Use Cases:** - Pre-fill tenant ID in SSO configuration forms - Validate domain is registered with Azure AD - Determine which Azure cloud environment contains the tenant  **Response:** - `success`: Whether tenant was discovered - `tenantId`: Azure AD tenant ID (UUID) - `cloud`: Primary cloud where tenant was found - `discoveredClouds`: List of all clouds where tenant exists 
     * @summary Discover Azure AD tenant from domain
     * @param {AzureTenantDiscoveryRequest} azureTenantDiscoveryRequest Domain discovery request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverAzureTenantPostRaw(requestParameters: DiscoverAzureTenantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AzureTenantDiscoveryResponse>>;

    /**
     * Discover Azure AD tenant ID from a domain name by checking all Azure cloud environments.  **Clouds Checked:** - Public Azure (login.microsoftonline.com) - US Government (login.microsoftonline.us) - China (login.chinacloudapi.cn) - Germany (login.microsoftonline.de)  **Use Cases:** - Pre-fill tenant ID in SSO configuration forms - Validate domain is registered with Azure AD - Determine which Azure cloud environment contains the tenant  **Response:** - `success`: Whether tenant was discovered - `tenantId`: Azure AD tenant ID (UUID) - `cloud`: Primary cloud where tenant was found - `discoveredClouds`: List of all clouds where tenant exists 
     * Discover Azure AD tenant from domain
     */
    discoverAzureTenantPost(requestParameters: DiscoverAzureTenantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AzureTenantDiscoveryResponse>;

    /**
     * Discover identity provider configuration from email address (public, unauthenticated)
     * @summary Discover identity provider for email
     * @param {string} email Email address to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverByEmailRaw(requestParameters: DiscoverByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>>;

    /**
     * Discover identity provider configuration from email address (public, unauthenticated)
     * Discover identity provider for email
     */
    discoverByEmail(requestParameters: DiscoverByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverByEmailEmptyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>>;

    /**
     */
    discoverByEmailEmpty(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverByEmailEmptySlashRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>>;

    /**
     */
    discoverByEmailEmptySlash(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult>;

    /**
     * Discover identity provider configuration for a domain (public, unauthenticated)
     * @summary Discover identity provider for domain
     * @param {string} domain Domain name to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverDomainRaw(requestParameters: DiscoverDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>>;

    /**
     * Discover identity provider configuration for a domain (public, unauthenticated)
     * Discover identity provider for domain
     */
    discoverDomain(requestParameters: DiscoverDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverDomainEmptyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>>;

    /**
     */
    discoverDomainEmpty(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    discoverDomainEmptySlashRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>>;

    /**
     */
    discoverDomainEmptySlash(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult>;

    /**
     * Retrieves a CSRF token for authenticated requests
     * @summary Get CSRF token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    getCsrfTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CsrfTokenResponse>>;

    /**
     * Retrieves a CSRF token for authenticated requests
     * Get CSRF token
     */
    getCsrfToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CsrfTokenResponse>;

    /**
     * Get user information from access token
     * @summary Get user info
     * @param {string} authorization Access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    getUserInfoRaw(requestParameters: GetUserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInfoResponse>>;

    /**
     * Get user information from access token
     * Get user info
     */
    getUserInfo(requestParameters: GetUserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInfoResponse>;

    /**
     * Logout user and invalidate tokens
     * @summary Logout
     * @param {LogoutRequest} logoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    logoutRaw(requestParameters: LogoutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogoutResponse>>;

    /**
     * Logout user and invalidate tokens
     * Logout
     */
    logout(requestParameters: LogoutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogoutResponse>;

}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI implements AuthenticationApiInterface {

    /**
     * Discover Azure AD tenant ID from a domain name. Same as POST /discover/azure-tenant but uses path parameter.
     * Discover Azure AD tenant from domain (GET)
     */
    async discoverAzureTenantGetRaw(requestParameters: DiscoverAzureTenantGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AzureTenantDiscoveryResponse>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling discoverAzureTenantGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover/azure-tenant/{domain}`;
        urlPath = urlPath.replace(`{${"domain"}}`, encodeURIComponent(String(requestParameters['domain'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AzureTenantDiscoveryResponseFromJSON(jsonValue));
    }

    /**
     * Discover Azure AD tenant ID from a domain name. Same as POST /discover/azure-tenant but uses path parameter.
     * Discover Azure AD tenant from domain (GET)
     */
    async discoverAzureTenantGet(requestParameters: DiscoverAzureTenantGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AzureTenantDiscoveryResponse> {
        const response = await this.discoverAzureTenantGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discover Azure AD tenant ID from a domain name by checking all Azure cloud environments.  **Clouds Checked:** - Public Azure (login.microsoftonline.com) - US Government (login.microsoftonline.us) - China (login.chinacloudapi.cn) - Germany (login.microsoftonline.de)  **Use Cases:** - Pre-fill tenant ID in SSO configuration forms - Validate domain is registered with Azure AD - Determine which Azure cloud environment contains the tenant  **Response:** - `success`: Whether tenant was discovered - `tenantId`: Azure AD tenant ID (UUID) - `cloud`: Primary cloud where tenant was found - `discoveredClouds`: List of all clouds where tenant exists 
     * Discover Azure AD tenant from domain
     */
    async discoverAzureTenantPostRaw(requestParameters: DiscoverAzureTenantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AzureTenantDiscoveryResponse>> {
        if (requestParameters['azureTenantDiscoveryRequest'] == null) {
            throw new runtime.RequiredError(
                'azureTenantDiscoveryRequest',
                'Required parameter "azureTenantDiscoveryRequest" was null or undefined when calling discoverAzureTenantPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/auth/discover/azure-tenant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AzureTenantDiscoveryRequestToJSON(requestParameters['azureTenantDiscoveryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AzureTenantDiscoveryResponseFromJSON(jsonValue));
    }

    /**
     * Discover Azure AD tenant ID from a domain name by checking all Azure cloud environments.  **Clouds Checked:** - Public Azure (login.microsoftonline.com) - US Government (login.microsoftonline.us) - China (login.chinacloudapi.cn) - Germany (login.microsoftonline.de)  **Use Cases:** - Pre-fill tenant ID in SSO configuration forms - Validate domain is registered with Azure AD - Determine which Azure cloud environment contains the tenant  **Response:** - `success`: Whether tenant was discovered - `tenantId`: Azure AD tenant ID (UUID) - `cloud`: Primary cloud where tenant was found - `discoveredClouds`: List of all clouds where tenant exists 
     * Discover Azure AD tenant from domain
     */
    async discoverAzureTenantPost(requestParameters: DiscoverAzureTenantPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AzureTenantDiscoveryResponse> {
        const response = await this.discoverAzureTenantPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discover identity provider configuration from email address (public, unauthenticated)
     * Discover identity provider for email
     */
    async discoverByEmailRaw(requestParameters: DiscoverByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling discoverByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover/email/{email}`;
        urlPath = urlPath.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainLookupResultFromJSON(jsonValue));
    }

    /**
     * Discover identity provider configuration from email address (public, unauthenticated)
     * Discover identity provider for email
     */
    async discoverByEmail(requestParameters: DiscoverByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult> {
        const response = await this.discoverByEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async discoverByEmailEmptyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover/email`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainLookupResultFromJSON(jsonValue));
    }

    /**
     */
    async discoverByEmailEmpty(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult> {
        const response = await this.discoverByEmailEmptyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async discoverByEmailEmptySlashRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover/email/`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainLookupResultFromJSON(jsonValue));
    }

    /**
     */
    async discoverByEmailEmptySlash(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult> {
        const response = await this.discoverByEmailEmptySlashRaw(initOverrides);
        return await response.value();
    }

    /**
     * Discover identity provider configuration for a domain (public, unauthenticated)
     * Discover identity provider for domain
     */
    async discoverDomainRaw(requestParameters: DiscoverDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling discoverDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover/{domain}`;
        urlPath = urlPath.replace(`{${"domain"}}`, encodeURIComponent(String(requestParameters['domain'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainLookupResultFromJSON(jsonValue));
    }

    /**
     * Discover identity provider configuration for a domain (public, unauthenticated)
     * Discover identity provider for domain
     */
    async discoverDomain(requestParameters: DiscoverDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult> {
        const response = await this.discoverDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async discoverDomainEmptyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainLookupResultFromJSON(jsonValue));
    }

    /**
     */
    async discoverDomainEmpty(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult> {
        const response = await this.discoverDomainEmptyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async discoverDomainEmptySlashRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainLookupResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/discover/`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainLookupResultFromJSON(jsonValue));
    }

    /**
     */
    async discoverDomainEmptySlash(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainLookupResult> {
        const response = await this.discoverDomainEmptySlashRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a CSRF token for authenticated requests
     * Get CSRF token
     */
    async getCsrfTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CsrfTokenResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/auth/csrf-token`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CsrfTokenResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a CSRF token for authenticated requests
     * Get CSRF token
     */
    async getCsrfToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CsrfTokenResponse> {
        const response = await this.getCsrfTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user information from access token
     * Get user info
     */
    async getUserInfoRaw(requestParameters: GetUserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInfoResponse>> {
        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling getUserInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }


        let urlPath = `/v1/auth/userinfo`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get user information from access token
     * Get user info
     */
    async getUserInfo(requestParameters: GetUserInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInfoResponse> {
        const response = await this.getUserInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Logout user and invalidate tokens
     * Logout
     */
    async logoutRaw(requestParameters: LogoutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogoutResponse>> {
        if (requestParameters['logoutRequest'] == null) {
            throw new runtime.RequiredError(
                'logoutRequest',
                'Required parameter "logoutRequest" was null or undefined when calling logout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/auth/logout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogoutRequestToJSON(requestParameters['logoutRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogoutResponseFromJSON(jsonValue));
    }

    /**
     * Logout user and invalidate tokens
     * Logout
     */
    async logout(requestParameters: LogoutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogoutResponse> {
        const response = await this.logoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
